define('modules/editor/views/property_boxes/page_privacy',['require','exports','module','./base','ldsh!../../templates/property_boxes/page_privacy'],function(require, exports, module){
  "use strict";
  var BasePropertyBox = require("./base");
  module.exports = BasePropertyBox.extend({
    template: require("ldsh!../../templates/property_boxes/page_privacy"),
    i18n: {
      "message": "editor.page.privacyDefaultMessage",
      "linkText": "editor.page.privacyDefaultLinkText",
      "title": "editor.page.privacyDefaultTitle"
    },
    onBeforeRender: function(){
      //set default values if empty
      //silent the change event to avoid triple-rendering!
      //this is called already in the render routine
      if(!this.model.get("message")){
        this.model.set("message", this.i18n.message, {silent:true});
      }
      if(!this.model.has("title")){
        this.model.set("title", this.i18n.title, {silent:true});
      }
      if(!this.model.get("linkText")){
        this.model.set("linkText", this.i18n.linkText, {silent:true});
      }
    }
  });
});

